import { Component, Input } from '@angular/core';

import { TwcPopupService } from '@topcon/twc-angular';

import { TranslationService } from '@mirage-projects/cw-commons';
import { ReportData } from '@mirage-projects/cw-models';
import { NumberHelperService } from '@mirage-projects/cw-utils';

import { ReportDetailComponent } from './report-detail/report-detail.component';

export type ReportType = 'user' | 'company';

/** This components displays a report with its graphic */
@Component({
    selector: 'cw-report',
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.scss'],
    standalone: false,
})
export class ReportComponent {
    /** Report Title */
    @Input() title!: string;

    /** Array with the tabs of the report */
    @Input() reportData!: ReportData[];

    /** show the detail of the report data */
    @Input() showDetail = false;

    @Input() type: ReportType = 'user';

    constructor(
        private numberHelperService: NumberHelperService,
        private translationService: TranslationService,
        private twcPopupService: TwcPopupService
    ) {}

    getValidPercentage(data: ReportData): string {
        const percentage = this.numberHelperService.isValidNumber(data.percentage)
            ? this.numberHelperService.toFixedWithPrecision(data.percentage, 1)
            : '-';

        return this.translationService.translate('REPORTS.USED_PERCENTAGE', { percentage: percentage });
    }

    getLoaderPercentage(data: ReportData): number {
        // TODO: Currently, the TWC progress-loader component does not support values greater than 100.
        return Math.min(data.percentage, 100);
    }

    getAccordionTitle(id: string): string {
        return `REPORTS.${id.toUpperCase()}_OBJECTS`;
    }

    getDetailIcon(): string {
        return this.type === 'company' ? 'factory' : 'user';
    }

    openDetail(data: ReportData): void {
        this.twcPopupService.open(ReportDetailComponent, {
            params: { caption: data.label, reportDetail: data.objectList, type: this.type },
        });
    }

    toFixedWithPrecision(value: any): number {
        return +this.numberHelperService.toFixedWithPrecision(value, 2);
    }
}
